// extracted by mini-css-extract-plugin
export default {"text":"uqIF4p"};